import { useEffect } from "react";
import { useAuthStore } from "../store/authStore";
import { authApi } from "../api/authApi";

interface AuthProviderProps {
  children: React.ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const { setUser, setLoading } = useAuthStore();

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem("accessToken");

      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const user = await authApi.getMe();
        setUser(user);
      } catch {
        // Token invalid, clear storage
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        setUser(null);
      }
    };

    initAuth();
  }, [setUser, setLoading]);

  return <>{children}</>;
}
